import { render, staticRenderFns } from "./CustomerLocationAdd.vue?vue&type=template&id=45a62468"
import script from "./CustomerLocationAdd.vue?vue&type=script&lang=js"
export * from "./CustomerLocationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports